import { render, staticRenderFns } from "./parts.vue?vue&type=template&id=210a112e&scoped=true&"
import script from "./parts.vue?vue&type=script&lang=ts&"
export * from "./parts.vue?vue&type=script&lang=ts&"
import style0 from "./parts.vue?vue&type=style&index=0&id=210a112e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210a112e",
  null
  
)

export default component.exports